var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',{key:_vm.settings.icon,staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"},[_c('statistics-card-line',{attrs:{"icon":_vm.settings.icon,"statistic":_vm.settings.value,"statisticTitle":_vm.settings.label,"type":"area"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }